export function chartFonts(theme = {}) {
  const label = theme.fontLabel || theme.fontHeading || theme.fontBody || 'Cohere Text';
  const number = theme.fontNumber || theme.fontBody || 'Cohere Text';
  const heading = theme.fontHeading || label;
  return { label, number, heading };
}
